/*
 Login component
 url match: / or /login
 Displays email id and password field
 with Login button
*/
import { withRouter, Link } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { loginStyles } from '../../Styles/loginStyles';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Loader from 'react-loader-spinner'
import InputAdornment from '@material-ui/core/InputAdornment';
import BackgroundImage from '../../Common/BackgroundImage';

@inject('userStore', 'commonStore')
@observer
class Login extends React.Component {

    state = {
        user: {
            email: "",
            password: ""
        },
        showError: false,
        validationErrors: {},
        showPassword: false
    }

    componentWillUnmount() {
        // this.props.userStore.reset();
    }

    componentDidMount() {
        if (this.props.userStore.token)
            this.props.history.push("/dashboard/drafts")
    }

    handleChange = (field, value) => {
        const user = Object.assign({}, this.state.user, {
            [field]: value
        });
        this.setState({ user });
    }

    //login - on click of login button
    login = (e) => {
        e.preventDefault();
        const { user } = this.state;
        this.setState({
            showError: false
        })
        if (!user.email || !user.password) {
            this.setState({ errorMessage: "Please enter email and password before proceeding." });
            return;
        }
        else {
            delete this.state.errorMessage;
            if (this.validateFields()) {
                this.setState({ errorMessage: undefined });
                this.props.userStore.login(user.email, user.password)
                    .then((res) => {
                        this.setState({
                            showError: true
                        })
                        if (this.props.userStore.loginFailed)
                            return
                        else {
                            this.props.userStore.getServerStatus()
                            if (this.props.userStore.isLocalTemplatePresent)
                                this.props.history.push("/dashboard/drafts")
                            else {
                                this.props.commonStore.openHelpDialog(true)
                                this.props.history.push("/dashboard/templates")
                            }
                        }

                    });
            }
            else
                return;

        }
    }

    //validation of form fields
    validateFields() {
        const { user, validationErrors } = this.state;
        const { userStore } = this.props
        let valid = true;
        if (!userStore.validateEmail(user.email)) {
            validationErrors['email'] = "Please enter a valid email address";
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors['email'];
        if (!user.password || user.password.length < 6 || user.password.length > 25) {
            validationErrors['password'] = "Please enter a valid password with min. 6 and max. 25 characters";
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors['password']
        if (valid) {
            delete validationErrors['email'];
            delete validationErrors['password'];
            this.setState({ validationErrors });
        }
        else
            delete validationErrors['password']
        return valid;
    }

    //handling functionality of hide/show password
    onClickShowPassword = (value) => {
        this.setState({
            showPassword: value
        })
    }
    render() {
        const { inProgress, loginFailed, statusText } = this.props.userStore;
        const { classes } = this.props;
        const { user, showError, validationErrors, showPassword } = this.state;

        return (
            <div className={classes.rowFlex} style={{ overflowY: 'hidden' }}>
                <div style={{ width: '50%' }}>
                    <BackgroundImage></BackgroundImage>
                </div>
                <div className="loginContainer">
                    <ReactSVG
                        beforeInjection={svg => {
                            svg.classList.add(classes.svg)
                        }}
                        src={Images.bigLogo} />
                    <p className={classes.pageHeading}>Welcome to ICR</p>
                    <form noValidate autoComplete="off" className={classes.formStyle}>
                        <FormControl error aria-describedby="component-error-text" className={classes.formControl}>
                            <TextField color="primary" style={{ paddingTop: 0, marginTop: 0 }} id="email"
                                label='Email'
                                margin="normal"
                                variant="filled"
                                InputProps={{
                                    disableUnderline: true
                                }}
                                
                                value={user.email}
                                onChange={(event) => this.handleChange("email", event.target.value)}
                            />
                            {validationErrors.email && <FormHelperText style={{ display: 'flex' }} id="email-input"><ReactSVG
                                beforeInjection={svg => {
                                    svg.classList.add(classes.svg)
                                }}
                                src={Images.error} />{validationErrors.email}</FormHelperText>}

                            <TextField
                                required
                                id="password-input"
                                label="Password"
                                type={showPassword ? 'text' : 'password'}
                                autoComplete="current-password"
                                margin="normal"
                                variant="filled"
                                fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    endAdornment: <InputAdornment position="end" >
                                        {!showPassword ? <ReactSVG src={Images.visibilityIcon} className={classes.showPassword} onClick={(e) => this.onClickShowPassword(true)} /> :
                                            <ReactSVG src={Images.visibilityOffIcon} className={classes.showPassword} onClick={(e) => this.onClickShowPassword(false)} />}
                                    </InputAdornment>

                                }}
                                value={user.password}
                                onChange={(event) => this.handleChange("password", event.target.value)}
                            />
                            {validationErrors.password && <FormHelperText id="password-input">
                                <ReactSVG
                                    beforeInjection={svg => {
                                        svg.classList.add(classes.svg)
                                    }}
                                    src={Images.error} />{validationErrors.password}</FormHelperText>}

                        </FormControl>
                        {this.state.errorMessage && <p style={{ display: 'flex', flexDirection: 'row' }} className={classes.errorStyle}><ReactSVG
                            beforeInjection={svg => {
                                svg.classList.add(classes.svg)
                            }}
                            src={Images.error} />{this.state.errorMessage}</p>}
                        {
                            inProgress ? <Button variant="contained" className={classes.button} fullWidth>
                                <Loader height={30} width={30} color={this.props.theme.palette.white} />
                            </Button> :
                                <Button variant="contained" className={classes.button} type="submit" onClick={this.login} fullWidth>
                                    Login
                      </Button>
                        }
                        {showError && loginFailed && <p style={{ display: 'flex', flexDirection: 'row' }} className={classes.errorStyle}><ReactSVG
                            beforeInjection={svg => {
                                svg.classList.add(classes.svg)
                            }}
                            src={Images.error} />{statusText}</p>}
                    </form>
                    <div className={classes.bottomAction}>
                        <Button component={Link} to="/register" className={classes.signup}>
                            Register
                    </Button>
                        <Button component={Link} to="/forgot-password" className={classes.signup}>
                            Forgot Password ?
                    </Button>
                    </div>
                </div>
            </div>
        );
    }
}
export default withStyles(loginStyles, { withTheme: true })(withRouter(Login));
